// extracted by mini-css-extract-plugin
module.exports = {"cartTotals":"CartTotals_cartTotals__3haHd","item":"CartTotals_item__1xblC","divider":"CartTotals_divider__3Vapz","ltr":"CartTotals_ltr__GaboS"};